import gql from 'graphql-tag';

export default gql`
  mutation updateProfiles ($input: updateHubsProfilesInput!) {
    updateHubsProfiles(input: $input) {
      viewer {
        id
        hubsProfiles {
          custom_profiles {
            img
            img_thumb_large
            type
            logo
            body
            headline
            quote
            best_place_to_eat
            class
            department
            desc
            fav_event
            fav_hangout
            fav_tradition
            hometown
            major
            persons_name
            program_name
            travel
            add_facts
            imgDisplayUrl
            logoDisplayUrl
            product_id
          }
        }
      }
    }
  }
`;
